// extracted by mini-css-extract-plugin
export default {"newsList":"index_newsList_eUos6","lietitem":"index_lietitem_y1oJO clearfix","title":"index_title_lCiBd"};